import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModuleProgressQuizPage } from './module-progress-quiz.page';

const routes: Routes = [
  {
    path: '',
    component: ModuleProgressQuizPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModuleProgressQuizPageRoutingModule {}
